import debounce from 'lodash.debounce';
import { convertDataLayerPayload } from '../transformers';
import { pushToDataLayer } from '..';

const debounces = {};

const pushImpression = payload => {
  if (!payload) {
    return;
  }

  const key = `${payload.listName || 'default-list'}-->${payload.currency}`;
  if (!debounces[key]) {
    debounces[key] = {
      stack: [],
      callback: debounce(() => {
        const stackToSplice = [...debounces[key].stack];

        while (stackToSplice.length) {
          const impressionsToPush = stackToSplice.splice(0, 10);

          pushToDataLayer({
            event: 'Ecommerce Bundled Impressions',
            ecommerce_list_currency: impressionsToPush[0].ecommerce_currency,
            ecommerce_list_items: impressionsToPush
          });
        }

        debounces[key].stack = [];
      }, 200)
    };
  }

  debounces[key].stack.push(convertDataLayerPayload(payload));
  debounces[key].callback();
};

export default pushImpression;
